import dataCenter from './dataCenter'

export default {
  dataCenter,
}
